namespace Queries {
    interface ICustomerQueryFilter
        extends IQueryFilter {

    }

    interface IPurchaseOrdered {
        ordered?: number;
    }
    export class CustomerQuery
        implements ITQueryInfo<Indexes.Customer, Entities.Customer, ICustomerQueryFilter, Entities.Customer> {
        
        private _repository: RavenDbClient;
    
        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async execute(context: ITQueryRequestContext<Indexes.Customer, Entities.Customer>) {

            const { results: results, stats: stats } = await this._repository.queryDocuments<Entities.Customer>("customers", "", {}, context.from, context.limit)

            return {
                docs: results,
                totalResults: stats.totalResults
            }
        }
        
    }
}